<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/n9X2cb/images/cover.jpg?1693516322402" alt="This image is the cover for the book Victory or Death, Emerging Revolutionary War Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Victory or Death, Emerging Revolutionary War Series
      </h1>
      <p class="bookDescription body article font2">
        <b>An overview of the military actions and battlefields of three consecutive engagements during the “ten crucial days” of the American Revolution.</b><br/><br/>December 1776: Just six months after the signing of the Declaration of Independence, George Washington and the new American Army sit on the verge of utter destruction by the banks of the Delaware River. The despondent and demoralized group of men had endured repeated defeats and now were on the edge of giving up hope. Washington feared “the game is pretty near up.”<br/><br/>Rather than submit to defeat, Washington and his small band of soldiers crossed the ice-choked Delaware River and attacked the Hessian garrison at Trenton, New Jersey, on the day after Christmas. He followed up the surprise attack with successful actions along the Assunpink Creek and at Princeton. In a stunning military campaign, Washington had turned the tables, and breathed life into the dying cause for liberty during the Revolutionary War.<br/><br/>The campaign has led many historians to deem it as one of the most significant military campaigns in American history. One British historian even declared that “it may be doubted whether so small a number of men ever employed so short a space of time with greater or more lasting results upon the history of the world.”<br/><br/>In <i>Victory or Death</i>, historian Mark Maloy not only recounts these epic events, he also takes you along to the places where they occurred. He shows where Washington stood on the banks of the Delaware and contemplated defeat, the city streets that his exhausted men charged through, and the open fields where Washington himself rode into the thick of battle. <i>Victory or Death</i> is a must for anyone interested in learning how George Washington and his brave soldiers grasped victory from the jaws of defeat.<br/><br/><b>“Maloy faithfully recreates the patriotic story of Washington’s crossing and brings the events of this period to life. The inclusion of the travel guide with turn-by-turn directions and photographs of what the places look like today makes the story more tangible and gives readers the ability to follow and walk in the footsteps of the Continental Army.” —Michael Britt, <i>ON POINT</i> Magazine</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Maloy
      </h2>
      
      <p class="authorDescription body article">Mark Maloy is a historian currently working for the National Park Service in Virginia. He holds an undergraduate degree in History from the College of William and Mary and a graduate degree in History from George Mason University. He has worked at numerous public historic sites and archaeological digs for the past ten years. He is an avid Revolutionary War reenactor and resides in Alexandria, Virginia with his wife, Lauren, and son, Samuel. He is a regular contributor to the blog Emerging Revolutionary War www.emergingrevolutionarywar.org.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Savas Beatie
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6fd709d6